






















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import store from '@/store';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwAppResponsiveHeader extends Vue {
  cssPrefix: String = 'sw-app-responsive-header';
  toggleNavMenu() {
    store.commit('toggleShowResponsiveNavMenu');
  }
}
